import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {

    constructor() {
    }
}



// WEBPACK FOOTER //
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/src/app/app.component.ts